export const GroupRoleQuerys = {
  GET_GROUP_ROLE: `query GetGroupRoleManagement($input: TgroupRoleManagementWhereInput!, $skip: Float!, $take: Float!){
    getGroupRoleManagement(where: $input, skip: $skip, take: $take){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
            id
            groupId
            jobTitle
            jobTitleName
            objectType
            plantId
            rewardId
            rewardStatus
            status
            tgroup{
                id
                name
            }
            unitId1
            unitName1
            unitId2
            unitName2
            unitId3
            unitName3
            unitId4
            unitName4
            unitId5
            unitName5
            unitId6
            unitName6
            unitId7
            unitName7
            unitId8
            unitName8
            unitId9
            unitName9
            unitId10
            unitName10
            createId
            createDate
            modifyId
            modifyDate
            tcreateUser{
                id
                fullName
            }
            tmodifyUser{
                id
                fullName
            }
        }
    }
}`,
  SAVE_GROUP_ROLE: `mutation CreateGroupRoleManagement($input: TgroupRoleManagementInput!){
    createGroupRoleManagement(input: $input){
        rewardId
        rewardStatus
        groupId
        plantId
        status
        objectType
        unitId1
        unitId2
        unitId3
        unitId4
        unitId5
        unitId6
        unitId7
        unitId8
        unitId9
        unitId10
        unitName1
        unitName2
        unitName3
        unitName4
        unitName5
        unitName6
        unitName7
        unitName8
        unitName9
        unitName10
    }
}`,
  GET_CBX_UNIT_LEVEL: ``,
  GET_CBX_POSITION: ``,
  GET_CBX_STATUS: ``,
  GET_CBX_OBJECT: ``,
  GET_CBX_GROUP: ``,
  //   Get combobox Group
  GET_COMBOBOX_GROUP_ROLE_MANAGEMENT: `query GetComboboxGroup($input: TcodeWhereInput!, $skip: Float!, $take: Float!){
    getCode(where: $input, skip: $skip, take: $take, orderBy: {
        name: ASC
    }){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
            id
            name
        }
    }
}`,
  // Get combobox Job title
  GET_COMBOBOX_JOB_TITLE: `query GetComboboxJobTitle($input: TJobTitleWhereInput!, $skip: Float!, $take: Float!){
    getJobTitle(where: $input, skip: $skip, take: $take){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
            id
            jobName
        }
    }
}`,
  // Get combobox Job title new
  GET_COMBOBOX_JOB_TITLE_NEW: `query GetComboboxGroupRoleManagement($input: TgroupRoleManagementWhereInput!, $skip: Float!, $take: Float!){
        getGroupRoleManagement(where: $input, skip: $skip, take: $take){
            pageInfo{
                currentPage
                hasNextPage
                hasPreviousPage
                itemsPerPage
                totalItems
                totalPages
            }
            items{
                id
                rewardId
                plantId
                jobTitle
                jobTitleName
            }
        }
    }`,
  // Update Group Role Management on/off
  UPDATE_GROUP_ROLE_MANAGEMENT_STATUS: `mutation UpdateGroupRoleManagement($input: TgroupRoleManagementInput!){
    updateGroupRoleManagement(input: $input){
        id
        status
    }
}`,
  // Update Group Role Management
  UPDATE_GROUP_ROLE_MANAGEMENT: `mutation UpdateGroupRoleManagement($input: TgroupRoleManagementInput!){
    updateGroupRoleManagement(input: $input){
        id
        rewardId
        jobTitle
        jobTitleName
        plantId
        unitId1
        unitName1
        unitId2
        unitName2
        unitId3
        unitName3
        unitId4
        unitName4
        groupId
        rewardStatus
        status
    }
}`,
};
